<template>
  <div class="grid-module" style="position: relative;">
    <template>
      <b-loading :is-full-page="false" :active="isPreloading" :can-cancel="false"></b-loading>
    </template>
    <section class="refer-earn">
      <h1>Refer a Friend</h1>
      <form class="refer-earn-form">
      <span class="label personal-info__field-label">
        Your personal Enhancify referral link:
      </span>
        <div class="columns refer-earn-copy-box">
          <div class="column refer-earn-input-box">
            <input class="link-input" :readonly="true" type="text" :value="pageReferralUrl"
                   ref="referralLink">
          </div>
          <div class="column refer-earn-btn-box">
            <div class="columns">
              <div class="column">
                <b-button type="is-success" outlined @click="copyLink">
                  {{ copyButtonText }}
                </b-button>
              </div>
              <div class="column">
                <b-button
                    type="is-success"
                    tag="a"
                    :href="`https://www.facebook.com/sharer/sharer.php?u=${pageReferralUrl}`"
                    target="_blank"
                    outlined>Share on Facebook</b-button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="how-it-work">
        <h3>How it works:</h3>
        <ol class="how-it-work-list">
          <li>
            1. Give your friends <strong>10%</strong>
            off the first year with Enhancify through your referral link.
          </li>
          <li>
            2. You earn <strong>$200</strong>
            for every friend that uses Enhancify for more than 30 days.
          </li>
          <li>3. Earn <strong>unlimited</strong> referral commission, paid out monthly.</li>
        </ol>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { referralUrl } from '../api/contractor';

export default {
  name: 'Refer',
  data: () => ({
    pageReferralUrl: null,
    copied: false,
    isPreloading: false,
  }),
  computed: {
    ...mapState('contractor', { id: (state) => state.id }),
    copyButtonText() {
      return this.copied ? 'Copied!' : 'Copy link';
    },
  },
  created() {
    if (!this.pageReferralUrl) this.loadData();
  },
  deactivated() {
    this.copied = false;
  },
  watch: {
    id() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      if (this.id === null) return;
      this.isPreloading = true;
      referralUrl(this.id)
        .then((response) => {
          if (!response.data.referralUrl) return;
          this.pageReferralUrl = response.data.referralUrl;
        })
        .catch(() => this.$buefy.toast.open({ message: 'An unexpected error occurred, please contact support@enhancify.com', type: 'is-danger', duration: 3000 }))
        .finally(() => {
          this.isPreloading = false;
        });
    },
    copyLink() {
      this.$refs.referralLink.select();
      document.execCommand('copy');
      this.copied = true;
      this.$buefy.toast.open({ message: 'Copied!', type: 'is-success', duration: 3000 });
    },
  },
};
</script>

<style lang="stylus">
.refer-earn
  h3
    font-weight 700
  &-form
    margin-top: 30px
  &-copy-box
    @media(min-width:769px)
      flex-direction: column
    @media(min-width:1336px)
      flex-direction: row
  &-input-box
    width: 100%
    input
      height: 36px
      width: 100%
      border: 1px solid rgba(143, 167, 179, 0.298039)
      border-radius: 3px
      color: #056ED6
      font-size: 16px
      padding: 0 16px
  &-btn-box.column
    width: 100%
    @media(min-width:1336px)
      width: 30%
      flex: none
    button, a
      width: 100%
  .how-it-work
    margin-top: 40px
    &-list
      list-style: none
      margin-top: 20px
      line-height 38px
</style>
